import React, { Component } from 'react';
import { ConfigProvider, Layout } from 'antd';
import RouteView from './route';
import Footer from './footer';
import Header from './header';
import Menu from './menu';

export default class Admin extends Component {
    render() {
        return (
            // <Layout
            //     style={{ width: '100vw', height: '100vh' }}
            // >
            <ConfigProvider
            >
                {/* <Layout.Content
                        style={{
                            overflowY: 'auto'
                        }}
                    > */}
                <Header />

                <div style={{ flexGrow: 2 }}>
                    <Menu
                        mode="inline"
                    />
                </div>
                <RouteView />

                {/* </Layout.Content> */}



                {/* <Layout.Footer
                        style={{ padding: '0' }}
                    > */}
                <Footer />
                {/* </Layout.Footer> */}

            </ConfigProvider>
            // </Layout>
        )
    }
}
